import axios from 'axios';
import header from "@/services/header";

const baseUrl = process.env.VUE_APP_BASE_URL;
const apiV1 = process.env.VUE_APP_API_V1;

const Documents = async (data) => {
  const docs = await axios.post(`${baseUrl + apiV1}/payment/documents`, data, header)
  return docs.data
}

const CheckDocuments = async (id, selfie) => {
  const query = `?id=${id}&SELFIE=${selfie}`
  const docs = await axios.get(`${baseUrl + apiV1}/payment/documents${query}`, header)
  return docs.data.data.digitalAccount._embedded.documents || docs.data.data.digitalAccount.content
}

export { Documents, CheckDocuments }
